var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoan1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H64C72.8366 0 80 7.16344 80 16V64C80 72.8366 72.8366 80 64 80H16C7.16344 80 0 72.8366 0 64V16Z",
    fill: "#FEEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4989_67298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0012 30.8552C34.9581 30.8552 30.8555 34.9579 30.8555 40.0006C30.8555 45.0437 34.9581 49.1463 40.0012 49.1463C45.0439 49.1463 49.1466 45.0437 49.1466 40.0006C49.1466 34.9579 45.0439 30.8552 40.0012 30.8552ZM45.431 38.2783L38.8791 44.8302C38.6041 45.1052 38.2434 45.2429 37.883 45.2429C37.5227 45.2429 37.1623 45.1056 36.8873 44.8302L34.3835 42.3264C33.8335 41.7767 33.8335 40.885 34.3835 40.3349C34.9332 39.7849 35.8249 39.7849 36.375 40.3349L37.883 41.843L43.4395 36.2869C43.9892 35.7368 44.8809 35.7368 45.431 36.2869C45.981 36.8365 45.981 37.7283 45.431 38.2783Z",
    fill: "#E95454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3894 29.0235L60.3879 28.9861C60.3671 28.5251 60.3531 28.0373 60.3447 27.4946C60.3055 24.848 58.2017 22.6588 55.5547 22.5108C50.0359 22.2028 45.7666 20.4033 42.1188 16.8477L42.0877 16.8181C40.8979 15.7271 39.1031 15.7271 37.9129 16.8181L37.8818 16.8477C34.234 20.4033 29.9647 22.2028 24.4459 22.5112C21.7993 22.6588 19.6951 24.848 19.6559 27.4949C19.6478 28.034 19.6335 28.5218 19.6127 28.9861L19.6105 29.0729C19.5032 34.7005 19.3699 41.7042 21.7129 48.0613C23.0012 51.5571 24.9524 54.5959 27.5118 57.0938C30.4268 59.9386 34.2449 62.197 38.8599 63.8061C39.0101 63.8585 39.1661 63.901 39.325 63.9328C39.5491 63.9775 39.7747 63.9998 40.0003 63.9998C40.2259 63.9998 40.4518 63.9775 40.6756 63.9328C40.8345 63.901 40.9916 63.8581 41.1425 63.8054C45.752 62.1933 49.5661 59.9338 52.4785 57.0895C55.0369 54.5908 56.988 51.5513 58.2775 48.0547C60.6293 41.6786 60.4963 34.6617 60.3894 29.0235ZM39.9996 51.9629C33.4034 51.9629 28.0373 46.5968 28.0373 40.0006C28.0373 33.4045 33.4034 28.0384 39.9996 28.0384C46.5954 28.0384 51.9618 33.4045 51.9618 40.0006C51.9618 46.5968 46.5954 51.9629 39.9996 51.9629Z",
    fill: "#E95454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4989_67298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoan1);
export default __webpack_public_path__ + "static/media/loan1.4820c2561712ffba87a4a7836420dd5a.svg";
export { ForwardRef as ReactComponent };